import { IdType } from 'utils/types/common';

export const BRAZIL_ID: IdType = 1;
